import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteLocationOverrideRule } from '../../../api/plan-location-override-rules-api'
import { LOCATION_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanLocationOverride/hooks/useGetLocationOverrideRules'

export function useDeleteLocationOverrideRule() {
  const queryClient = useQueryClient()

  return useMutation<void, unknown, string>({
    mutationFn: (id) => deleteLocationOverrideRule(id),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [LOCATION_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
